<template>
    <b-modal v-if="!loading" id="facility_form" ref="facility_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add New Facility' : 'Edit Facility' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row v-if="validationError">
                <b-colxx md="12">
                    <b-alert class="text-center" show variant="danger"
                             v-text="validationError"/>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Code" class="has-float-label">
                        <template v-slot:label>
                            <span>Code <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.code" :class="{'border-danger': 'code' in errors}"
                                      @input="'code' in errors ? delete errors.code : ''"
                                      autocomplete="off" placeholder="Facility Code"/>

                        <b-form-invalid-feedback :state="!'code' in errors"
                                                 v-text="'code' in errors ? errors.code[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Type" class="has-float-label">
                        <template v-slot:label>
                            <span>Type <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateType" v-model="selected.type" :options="types"
                                  :border-danger="'type' in errors"/>

                        <b-form-invalid-feedback :state="!'type' in errors"
                                                 v-text="'type' in errors ? errors.type[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Name/Address" class="has-float-label">
                        <template v-slot:label>
                            <span>Name/Address <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? delete errors.name : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'name' in errors"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Vendor" class="has-float-label">
                        <template v-slot:label>
                            <span>Vendor <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateVendor" v-model="selected.vendor" :options="vendors"
                                  :border-danger="'vendor_id' in errors"/>

                        <b-form-invalid-feedback :state="!'vendor_id' in errors"
                                                 v-text="'vendor_id' in errors ? errors.vendor_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="City" class="has-float-label">
                        <template v-slot:label>
                            <span>City <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.city" :class="{'border-danger': 'city' in errors}"
                                      @input="'city' in errors ? delete errors.city : ''"
                                      autocomplete="off" placeholder="City"/>

                        <b-form-invalid-feedback :state="!'city' in errors"
                                                 v-text="'city' in errors ? errors.city[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="State" class="has-float-label">
                        <template v-slot:label>
                            <span>State <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateState" v-model="selected.state" :options="states"
                                  :border-danger="'state_id' in errors"/>

                        <b-form-invalid-feedback :state="!('state_id' in errors)"
                                                 v-text="'state_id' in errors ? errors.state_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="ZIP" class="has-float-label">
                        <template v-slot:label>
                            <span>ZIP <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-mask="'#####'" :class="{'border-danger': 'zip' in errors}"
                                      @input="'zip' in errors ? delete errors.zip : ''"
                                      v-model="form.zip" placeholder="XXXXX" autocomplete="off"/>

                        <b-form-invalid-feedback :state="!'zip' in errors"
                                                 v-text="'zip' in errors ? errors.zip[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Contact" class="has-float-label">
                        <template v-slot:label>
                            <span>Contact <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" :class="{'border-danger': 'contact' in errors}"
                                      @input="'contact' in errors ? delete errors.contact : ''"
                                      v-model="form.contact" autocomplete="off" placeholder="Contact"/>

                        <b-form-invalid-feedback :state="!'contact' in errors"
                                                 v-text="'contact' in errors ? errors.contact[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Email" class="has-float-label">
                        <template v-slot:label>
                            <span>Email <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" :class="{'border-danger': 'email' in errors}"
                                      @input="'email' in errors ? delete errors.email : ''"
                                      v-model="form.email" autocomplete="off" placeholder="Email"/>

                        <b-form-invalid-feedback :state="!'email' in errors"
                                                 v-text="'email' in errors ? errors.email[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Phone" class="has-float-label">
                        <template v-slot:label>
                            <span>Phone <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-mask="'(###) ###-####'"
                                      :class="{'border-danger': 'phone' in errors}"
                                      @input="'phone' in errors ? delete errors.phone : ''"
                                      v-model="form.phone" placeholder="(XXX) XXX-XXXX" autocomplete="off"/>

                        <b-form-invalid-feedback :state="!'phone' in errors"
                                                 v-text="'phone' in errors ? errors.phone[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Start (HASA)" class="has-float-label">
                        <template v-slot:label>
                            <span>Start (HASA) <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.start_hasa"
                            @input="'start_hasa' in errors ? delete errors.start_hasa : ''"
                            :input-props="{ class:'form-control' + ('start_hasa' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'start_hasa' in errors"
                                                 v-text="'start_hasa' in errors ? errors.start_hasa[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Start (EHP)" class="has-float-label">
                        <template v-slot:label>
                            <span>Start (EHP) <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-align="right" popover-visibility="focus" mode="single"
                            v-model="datepicker.start_ehp" @input="'start_ehp' in errors ? delete errors.start_ehp : ''"
                            :input-props="{ class:'form-control' + ('start_ehp' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'start_ehp' in errors"
                                                 v-text="'start_ehp' in errors ? errors.start_ehp[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Contract From" class="has-float-label">
                        <template v-slot:label>
                            <span>Contract From <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single" v-model="datepicker.mou_from"
                            @input="'mou_from' in errors ? delete errors.mou_from : ''"
                            :input-props="{ class:'form-control' + ('mou_from' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'mou_from' in errors"
                                                 v-text="'mou_from' in errors ? errors.mou_from[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Contract To" class="has-float-label">
                        <template v-slot:label>
                            <span>Contract To <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-align="right" popover-visibility="focus" mode="single" v-model="datepicker.mou_to"
                            @input="'mou_to' in errors ? delete errors.mou_to : ''"
                            :input-props="{ class:'form-control' + ('mou_to' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'mou_to' in errors"
                                                 v-text="'mou_to' in errors ? errors.mou_to[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="4">
                    <b-form-group label="EIN" class="has-float-label">
                        <template v-slot:label>
                            <span>EIN <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-mask="'##-#######'" :class="{'border-danger': 'ein' in errors}"
                                      @input="'ein' in errors ? delete errors.ein : ''"
                                      v-model="form.ein" placeholder="XX-XXXXXXX" autocomplete="off"/>

                        <b-form-invalid-feedback :state="!'ein' in errors"
                                                 v-text="'ein' in errors ? errors.ein[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="4">
                    <b-form-group label="Rate" class="has-float-label">
                        <template v-slot:label>
                            <span>Rate <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" :class="{'border-danger': 'rate' in errors}"
                                      @input="'rate' in errors ? delete errors.rate : ''"
                                      v-model="form.rate" autocomplete="off" placeholder="Rate"/>

                        <b-form-invalid-feedback :state="!'rate' in errors"
                                                 v-text="'rate' in errors ? errors.rate[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="4">
                    <b-form-group label="Total Units" class="has-float-label">
                        <template v-slot:label>
                            <span>Total Units <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" :class="{'border-danger': 'total_units' in errors}"
                                      @input="'total_units' in errors ? delete errors.total_units : ''"
                                      v-model="form.total_units" autocomplete="off" placeholder="Total Units"/>

                        <b-form-invalid-feedback :state="!'total_units' in errors"
                                                 v-text="'total_units' in errors ? errors.total_units[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group>
                        <b-form-checkbox v-model="form.medicine">Medicine</b-form-checkbox>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group>
                        <b-form-checkbox v-model="form.smoke_free">Smoke-free</b-form-checkbox>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group>
                        <b-form-checkbox v-model="form.handicap_access">Handicap Access
                        </b-form-checkbox>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group>
                        <b-form-checkbox v-model="form.elevator">Elevator</b-form-checkbox>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row class="mb-4">
                <b-colxx md="12">
                    <vue-dropzone ref="fileDropZone" id="dropzone"
                                  @vdropzone-error="attachmentError"
                                  :destroy-dropzone="false" :options="dropzoneOptions"/>
                </b-colxx>
            </b-row>

            <b-row v-if="edit">
                <b-colxx md="12">
                    <FilesList v-if="form.attachments" :edit="true" :files="form.attachments.data" @delete="deleteFile"/>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12" class="mb-4">
                    <b-form-group label="Notes" class="has-float-label">
                        <b-form-textarea v-model="form.notes" rows="6" placeholder="Notes"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('facility_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitFacility">Submit</state-button>

            <state-button v-else variant="primary" :click="updateFacility">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
    import {mapGetters} from "vuex";
    import moment from "moment";
    import VueDropzone from 'vue2-dropzone';
    import StateButton from "../../../../../components/Common/StateButton";
    import FilesList from "../../../../../components/Listing/FilesList";

    export default {
        name: "FacilityFormModal",

        components: {
            FilesList,
            VueDropzone,
            StateButton,
        },

        props: [
            'edit',
        ],

        data() {
            return {
                loading: true,
                datepicker: {
                    start_hasa: null,
                    start_ehp: null,
                    mou_from: null,
                    mou_to: null,
                },
                validationError: null,
                selected: {
                    type: [],
                    vendor: [],
                    state: [],
                },
                types: [
                    {label: 'Single', value: 'Single'},
                    {label: 'Family', value: 'Family'},
                ],
                deleted_attachments: [],
                dropzoneOptions: {
                    url: 'url',
                    thumbnailHeight: 160,
                    acceptedFiles: '.jpg,.jpeg,.png,.pdf',
                    maxFilesize: 10,
                    previewTemplate: this.dropzoneTemplate(),
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.getters.accessToken
                    },
                    dictDefaultMessage: 'Drop or Click here to upload files.<br>Max file size 10MB.<br>Accepted file types: JPG, JPEG, PNG, PDF.',
                    autoProcessQueue: false
                },
            }
        },

        computed: {
            ...mapGetters({
                form: 'getFacilityForm',
                states: 'getSelectStates',
                vendors: 'getSelectVendors',
                errors: 'getFacilityErrors',
            }),
        },

        watch: {
            form() {
                if (this.edit) {
                    this.selected.vendor = this.form.select_vendor;
                    this.selected.state = this.form.select_state;
                    this.selected.type = this.form.select_type;

                    this.datepicker.start_hasa = moment(this.form.start_hasa).toDate();
                    this.datepicker.start_ehp = moment(this.form.start_ehp).toDate();
                    this.datepicker.mou_from = moment(this.form.mou_from).toDate();
                    this.datepicker.mou_to = moment(this.form.mou_to).toDate();
                }
            },

            'datepicker.start_hasa'(date) {
                if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.start_hasa = null;
                this.form.start_hasa = moment(date).format('YYYY-MM-DD');
            },
            'datepicker.start_ehp'(date) {
                if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.start_ehp = null;
                this.form.start_ehp = moment(date).format('YYYY-MM-DD');
            },
            'datepicker.mou_from'(date) {
                if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.mou_from = null;
                this.form.mou_from = moment(date).format('YYYY-MM-DD');
            },
            'datepicker.mou_to'(date) {
                if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.mou_to = null;
                this.form.mou_to = moment(date).format('YYYY-MM-DD');
            },
        },

        mounted() {
            this.getFormData();
        },

        methods: {
            deleteFile(file) {
                this.deleted_attachments.unshift(file);
                this.form.attachments.data.splice(file.index, 1);
            },

            submitFacility() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('submitFacility', this.form)
                        .then(response => {
                            this.uploadFiles(response.data);
                        })
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Added new facility!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('facility_form');
                            }, 2000);
                        })
                        .catch(error => {
                            if (error.response.data.error) {
                                this.validationError = error.response.data.error;
                            }

                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            updateFacility() {
                let payload = {
                    ...this.form,
                    deleted_attachments: this.deleted_attachments,
                };

                return new Promise((success, fail) => {
                    this.$store.dispatch('updateFacility', payload)
                        .then(response => {
                            this.uploadFiles(response.data);
                        })
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Updated the facility!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('facility_form');
                            }, 2000);
                        })
                        .catch(error => {
                            if (error.response.data.error) {
                                this.validationError = error.response.data.error;
                            }

                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            async getFormData() {
                await this.$store.dispatch('fetchSelectStates');

                await this.$store.dispatch('fetchSelectVendors');

                return this.loading = false;
            },

            uploadFiles(facility) {
                let url = '/api/hms/locations/facilities/' + facility.facility_id + '/attachments';

                this.$refs.fileDropZone.setOption('url', url);

                this.$refs.fileDropZone.processQueue(facility);
            },

            attachmentError(file, message, xhr) {
                this.$refs.fileDropZone.removeFile(file);
                this.$notify('error filled', 'Error!', file.name + " could not be added!", {
                    duration: 6000,
                    permanent: false
                });
            },

            dropzoneTemplate() {
                return `<div class="dz-preview dz-file-preview mb-3">
                  <div class="d-flex flex-row "> <div class="p-0 w-30 position-relative">
                      <div class="dz-error-mark"><span><i></i>  </span></div>
                      <div class="dz-success-mark"><span><i></i></span></div>
                      <div class="preview-container">
                        <img data-dz-thumbnail class="img-thumbnail border-0" />
                        <i class="simple-icon-doc preview-icon"></i>
                      </div>
                  </div>
                  <div class="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                    <div> <span data-dz-name /> </div>
                    <div class="text-primary text-extra-small" data-dz-size /> </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                  </div>
                  <a href="#" class="remove" data-dz-remove> <i class="glyph-icon simple-icon-trash"></i> </a>
                </div>`
            },

            updateType(field) {
                if (field) {
                    this.form.type = field.value;
                } else {
                    this.form.type = '';
                }
                'type' in this.errors ? delete this.errors.type : '';
            },

            updateVendor(field) {
                if (field) {
                    this.form.vendor_id = field.vendor_id;
                } else {
                    this.form.vendor_id = '';
                }
                'vendor_id' in this.errors ? delete this.errors.vendor_id : '';
            },

            updateState(field) {
                if (field) {
                    this.form.state_id = field.state_id;
                } else {
                    this.form.state_id = '';
                }
                'state_id' in this.errors ? delete this.errors.state_id : '';
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },

            resetForm() {
                this.$store.commit('setFacilityForm');

                this.selected = {
                    type: [],
                    vendor: [],
                    state: [],
                };

                this.validationError = null;

                this.deleted_attachments = [];
            },
        },
    }
</script>

<style scoped>

</style>
